exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".drag[data-v-727d74d9]{display:inline-block}.drag.A[data-v-727d74d9]{background:#aaa}.drag.B[data-v-727d74d9]{background:#888}.drag.C[data-v-727d74d9]{background:#666}.drag.D[data-v-727d74d9]{background:#444}.drag.E[data-v-727d74d9]{background:#222}.drag.F[data-v-727d74d9]{background:#000}.drop[data-v-727d74d9]{display:inline-block;vertical-align:top;padding:15px;margin-bottom:20px;width:auto;height:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-727d74d9","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Lists.vue
// module id = 25
// module chunks = 0